import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatIconModule } from "@angular/material/icon";
import { MatRadioModule } from "@angular/material/radio";

import { MatInputModule } from "@angular/material/input";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { OAuthModule } from "angular-oauth2-oidc";

// Config path
import { APP_ROUTING } from "./app-routing.module";

// Service
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { HomeAllRequestService } from "./components/layout/service/home-all-request.service";
import { SeeAllRequestService } from "./components/layout/service/see-all-request.service";
import { FormCheckPolicyService } from "./components/layout/service/form-check-policy.service";
import { PolicyListService } from "./components/layout/service/policy-list.service";
import { PolicyApproversListService } from "./components/layout/service/policy-approvers-list.service";
import { AdminZoneService } from "./components/layout/service/admin-zone.service";
import { AspectsAdminService } from "./components/layout/service/aspects-admin.service";
import { PickupListService } from "./components/layout/service/pickup-list.service";
import { AdminSubZoneService } from "./components/layout/service/admin-sub-zone.service";
import { AdminFaqSectionService } from "./components/layout/service/admin-faq-section.service";
import { TokenInterceptorService } from "./components/layout/service/token-interceptor.service";
import { CardApproverService } from "./components/layout/service/card-approver.service";

import { AppComponent } from "./app.component";
import { HeaderComponent } from "./components/layout/header/header.component";
import { HomeComponent } from "./components/layout/body-home/home.component";
import { FooterComponent } from "./components/layout/footer/footer.component";
import { NgxSortableModule } from "ngx-sortable";
import { PaginatePipe } from "./components/layout/pipes/paginate.pipe";
import {
  MatPaginatorModule,
  MatPaginatorIntl,
} from "@angular/material/paginator";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

// Translation
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";
import { DatePipe } from "@angular/common";
import { NumberDirective } from "./numbers-only.directive";

// Modals
import { FormCheckPolicyComponent } from "./components/layout/form-check-policy/form-check-policy.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ModTermsComponent } from "./components/layout/modals/mod-terms/mod-terms.component";
import { ModCanReqComponent } from "./components/layout/modals/mod-can-req/mod-can-req.component";
import { ModApReqComponent } from "./components/layout/modals/mod-ap-req/mod-ap-req.component";
import { ModModReqComponent } from "./components/layout/modals/mod-mod-req/mod-mod-req.component";
import { ModModReq2Component } from "./components/layout/modals/mod-mod-req2/mod-mod-req2.component";
import { ModPhoPreComponent } from "./components/layout/modals/mod-pho-pre/mod-pho-pre.component";
import { ModQualComponent } from "./components/layout/modals/mod-qual/mod-qual.component";
import { ModQualExComponent } from "./components/layout/modals/mod-qual-ex/mod-qual-ex.component";
import { TranslateComponent } from "./components/translate/translate.component";
import { PolicyListComponent } from "./components/layout/policy-list/policy-list.component";
import { PolicyResultComponent } from "./components/layout/policy-result/policy-result.component";
import { ModalsConfirmComponent } from "./components/layout/form-check-policy/modals-confirm/modals-confirm.component";
import { PolicyApproverComponent } from "./components/layout/policy-approver/policy-approver.component";
import { ModalsRejectComponent } from "./components/layout/policy-approver/modals-reject/modals-reject.component";
import { ModalsAcceptComponent } from "./components/layout/policy-approver/modals-accept/modals-accept.component";
import { ModalsSiteAddComponent } from "./components/layout/admin-sites/modals-site-add/modals-site-add.component";
import { AdminSitesComponent } from "./components/layout/admin-sites/admin-sites.component";
import { ModalsSiteEditComponent } from "./components/layout/admin-sites/modals-site-edit/modals-site-edit.component";
import { AdminAspectsListComponent } from "./components/layout/admin-aspects-list/admin-aspects-list.component";
import { ModalsAddComponent } from "./components/layout/admin-aspects-list/modals-add/modals-add.component";
import { ModalsEditComponent } from "./components/layout/admin-aspects-list/modals-edit/modals-edit.component";
import { AdminZoneComponent } from "./components/layout/admin-zone/admin-zone.component";
import { AddZoneComponent } from "./components/layout/admin-zone/add-zone/add-zone.component";
import { EditZoneComponent } from "./components/layout/admin-zone/edit-zone/edit-zone.component";
import { AdminPickupListComponent } from "./components/layout/admin-pickup-list/admin-pickup-list.component";
import { PickupAddComponent } from "./components/layout/admin-pickup-list/pickup-add/pickup-add.component";
import { PickupEditComponent } from "./components/layout/admin-pickup-list/pickup-edit/pickup-edit.component";
import { AdminSubZoneComponent } from "./components/layout/admin-sub-zone/admin-sub-zone.component";
import { AddSubZoneComponent } from "./components/layout/admin-sub-zone/add-sub-zone/add-sub-zone.component";
import { EditSubZoneComponent } from "./components/layout/admin-sub-zone/edit-sub-zone/edit-sub-zone.component";
import { NewAccessCardComponent } from "./components/layout/new-access-card/new-access-card.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { ModalsConfirmCardComponent } from "./components/layout/new-access-card/modals-confirm-card/modals-confirm-card.component";
import { AdminFaqSectionComponent } from "./components/layout/admin-faq-section/admin-faq-section.component";
import { AddSectionComponent } from "./components/layout/admin-faq-section/add-section/add-section.component";
import { EditSectionComponent } from "./components/layout/admin-faq-section/edit-section/edit-section.component";
import { AdminFaqQaComponent } from "./components/layout/admin-faq-qa/admin-faq-qa.component";
import { EditQaComponent } from "./components/layout/admin-faq-qa/edit-qa/edit-qa.component";
import { AddQaComponent } from "./components/layout/admin-faq-qa/add-qa/add-qa.component";
import { FaqPublicComponent } from "./components/layout/faq-public/faq-public.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { NewCardsResultComponent } from "./components/layout/new-cards-result/new-cards-result.component";
import { NewCardsListComponent } from "./components/layout/new-cards-list/new-cards-list.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { ModalImageAcceptComponent } from "./components/layout/new-access-card/modal-image-accept/modal-image-accept.component";
import { CardRepositionComponent } from "./components/layout/card-reposition/card-reposition.component";
import { CardsListResultComponent } from "./components/layout/cards-list-result/cards-list-result.component";
import { CardApproverListComponent } from "./components/layout/card-approver-list/card-approver-list.component";
import { CardApproverResultComponent } from "./components/layout/card-approver-result/card-approver-result.component";
import { ModalApproveAcceptComponent } from "./components/layout/card-approver-result/modal-approve-accept/modal-approve-accept.component";
import { ProfileComponent } from "./components/layout/profile/profile.component";
import { AddComponent } from "./components/layout/profile/add/add.component";
import { EditComponent } from "./components/layout/profile/edit/edit.component";
import { AngularDualListBoxModule } from "angular-dual-listbox";
import { PickupcardsComponent } from "./components/layout/pickupcards/pickupcards.component";
import { NotFoundPageComponent } from "./components/layout/not-found-page/not-found-page.component";
import { NotModulesComponent } from "./components/layout/not-modules/not-modules.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { ModalsScaleComponent } from "./components/layout/policy-approver/modals-scale/modals-scale.component";
import { ModalsObservationComponent } from "./components/layout/policy-list/modals-observation/modals-observation.component";
import { CheckPolicyManagementComponent } from "./components/layout/check-policy-management/check-policy-management.component";
import { EmployeAccessComponent } from "./components/layout/employe-access/employe-access.component";
import { AccessEmployeeListComponent } from "./components/layout/access-employee-list/access-employee-list.component";
import { AccessEmployeeResultComponent } from "./components/layout/access-employee-result/access-employee-result.component";
import { QualificationsModalComponent } from "./components/layout/employe-access/qualifications-modal/qualifications-modal.component";
import { AdminBusinessUnitComponent } from "./components/layout/admin-business-unit/admin-business-unit.component";
import { AddBuComponent } from "./components/layout/admin-business-unit/add-bu/add-bu.component";
import { EditBuComponent } from "./components/layout/admin-business-unit/edit-bu/edit-bu.component";
import { AccessConfirmationComponent } from "./components/layout/access-confirmation/access-confirmation.component";
import { AccessApproversListComponent } from "./components/layout/access-approvers-list/access-approvers-list.component";
import { AccessContractComponent } from "./components/layout/access-contract/access-contract.component";
import { SubZoneApproversComponent } from "./components/layout/admin-sub-zone/sub-zone-approvers/sub-zone-approvers.component";
import { ModalApproverSubzoneComponent } from "./components/layout/admin-sub-zone/sub-zone-approvers/modal-approver-subzone/modal-approver-subzone.component";
import { ConfimDeleteApproverComponent } from "./components/layout/admin-sub-zone/sub-zone-approvers/confim-delete-approver/confim-delete-approver.component";
import { AccessIncomingRequestListComponent } from "./components/layout/access-incoming-request-list/access-incoming-request-list.component";
import { AccessIncomingRequestDetailsComponent } from "./components/layout/access-incoming-request-details/access-incoming-request-details.component";
import { ModalApproveComponent } from "./components/layout/access-incoming-request-details/modal-approve/modal-approve.component";
import { ModalRejectComponent } from "./components/layout/access-incoming-request-details/modal-reject/modal-reject.component";
import { AccessExceptionComponent } from "./components/layout/access-exception/access-exception.component";
import { AccessIncomingRequestConfirmComponent } from "./components/layout/access-incoming-request-confirm/access-incoming-request-confirm.component";
import { ModalTermsComponent } from "./components/layout/body-home/modal-terms/modal-terms.component";
import { AccessVisitorComponent } from "./components/layout/access-visitor/access-visitor.component";
import { MyAuthorisedAccessesComponent } from "./components/layout/self-verification/my-authorised-accesses/my-authorised-accesses.component";
import { MyAccessesAuthorisedDetailComponent } from "./components/layout/self-verification/my-accesses-authorised-detail/my-accesses-authorised-detail.component";
import { MyQualificationListComponent } from "./components/layout/self-verification/my-qualification-list/my-qualification-list.component";
import { AdminI18nSarComponent } from "./components/layout/admin-i18n-sar/admin-i18n-sar.component";
import { AdminI18nPublicComponent } from "./components/layout/admin-i18n-public/admin-i18n-public.component";
import { AdminSelfInformationComponent } from "./components/layout/admin-sites/admin-self-information/admin-self-information.component";
import { AddSelfInformationComponent } from "./components/layout/admin-sites/admin-self-information/add-self-information/add-self-information.component";
import { EditSelfInformationComponent } from "./components/layout/admin-sites/admin-self-information/edit-self-information/edit-self-information.component";
import { DeleteSelfInformationComponent } from "./components/layout/admin-sites/admin-self-information/delete-self-information/delete-self-information.component";
import { environment } from "../environments/environment";
import { CalificationDummyComponent } from "./components/layout/admin-zone/calification-dummy/calification-dummy.component";
import { QualificationDummySubZoneComponent } from "./components/layout/admin-sub-zone/qualification-dummy-sub-zone/qualification-dummy-sub-zone.component";
import { FacilityApproverZoneComponent } from "./components/layout/admin-zone/facility-approver-zone/facility-approver-zone.component";
import { FacilityApproverSubzoneComponent } from "./components/layout/admin-sub-zone/facility-approver-subzone/facility-approver-subzone.component";
import { ModalsConfirmAccessEmployeeContractorComponent } from "./components/layout/employe-access/modals-confirm/modals-confirm.component";
import { ModalTermsVisitorComponent } from "./components/layout/access-visitor/modal-terms-visitor/modal-terms-visitor.component";
import { ModalTermsAcceptRequestComponent } from "./components/layout/access-incoming-request-details/modal-terms-accept-request/modal-terms-accept-request.component";
import { ModalTermsRepositionComponent } from "./components/layout/card-reposition/modal-terms-reposition/modal-terms-reposition.component";
import { ModalTerminateComponent } from "./components/layout/access-employee-result/modal-terminate/modal-terminate.component";
import { PublicFooterComponent } from "./components/public/layout/public-footer/public-footer.component";
import { PublicHeaderComponent } from "./components/public/layout/public-header/public-header.component";
import { ConfirmationPublicFormComponent } from "./components/public/access-form-public/confirmation-public-form/confirmation-public-form.component";
import { LeaderGroupAccessFormComponent } from "./components/public/access-form-public/leader-group-access-form/leader-group-access-form.component";
import { ModalConfirmComponent } from "./components/public/access-form-public/modal-confirm/modal-confirm.component";
import { PersonalFormAccessComponent } from "./components/public/access-form-public/personal-form-access/personal-form-access.component";
import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";
import { MedicalTestComponent } from "./components/public/medical-test/medical-test.component";
import { ConfirmationMedicalComponent } from "./components/public/medical-test/confirmation-medical/confirmation-medical.component";
import { MatPaginatorI18nService } from "./components/layout/service/mat-paginator-i18n.service";
import { ModErrorComponent } from "./components/layout/modals/mod-error/mod-error.component";
import { ModalExceptionConfirmComponent } from "./components/layout/access-exception/modal-exception-confirm/modal-exception-confirm.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { SaaDelegateComponent } from "./components/layout/saa-delegate/saa-delegate.component";
import { ModalDelegateConfirmationComponent } from "./components/layout/saa-delegate/modal-delegate-confirmation/modal-delegate-confirmation.component";
import { SaaDelegateConfirmationComponent } from "./components/layout/saa-delegate/saa-delegate-confirmation/saa-delegate-confirmation.component";
import { ModalEditDelegateComponent } from "./components/layout/saa-delegate/modal-edit-delegate/modal-edit-delegate.component";
import { ModalDeleteDelegateComponent } from "./components/layout/saa-delegate/modal-delete-delegate/modal-delete-delegate.component";
import { ExternalVerificationComponent } from "./components/layout/external-verification/external-verification.component";
import { ExternalVerificationListComponent } from "./components/layout/external-verification-list/external-verification-list.component";
import { ExternalVerificationDetailsComponent } from "./components/layout/external-verification-details/external-verification-details.component";
import { UnauthBackendComponent } from "./components/layout/unauth-backend/unauth-backend.component";

import { VisitorVerificationComponent } from "./components/layout/visitor-verification/visitor-verification.component";
import { VisitorVerificationListComponent } from "./components/layout/visitor-verification-list/visitor-verification-list.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule } from "@angular/material/core";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    environment.bffBaseUrl + "/i18n/",
    "?type=sar"
  );
}

@NgModule({
  declarations: [
  AppComponent,
  HeaderComponent,
  HomeComponent,
  FooterComponent,
  PaginatePipe,
  ModTermsComponent,
  ExternalVerificationListComponent,
  ExternalVerificationComponent,
  ExternalVerificationDetailsComponent,
  VisitorVerificationListComponent,
  VisitorVerificationComponent,
  ModCanReqComponent,
  ModApReqComponent,
  ModModReqComponent,
  AccessConfirmationComponent,
  ModModReq2Component,
  ModPhoPreComponent,
  ModQualComponent,
  ModQualExComponent,
  TranslateComponent,
  FormCheckPolicyComponent,
  PolicyResultComponent,
  PolicyListComponent,
  ModalsConfirmComponent,
  ModalsConfirmAccessEmployeeContractorComponent,
  PolicyApproverComponent,
  ModalsRejectComponent,
  ModalsAcceptComponent,
  ModalsSiteAddComponent,
  AdminSitesComponent,
  ModalsSiteEditComponent,
  AdminAspectsListComponent,
  ModalsAddComponent,
  ModalsEditComponent,
  AdminPickupListComponent,
  PickupAddComponent,
  PickupEditComponent,
  AdminZoneComponent,
  AddZoneComponent,
  EditZoneComponent,
  AdminSubZoneComponent,
  AddSubZoneComponent,
  EditSubZoneComponent,
  NewAccessCardComponent,
  NewCardsResultComponent,
  FaqPublicComponent,
  EditSubZoneComponent,
  AdminFaqSectionComponent,
  AddSectionComponent,
  EditSectionComponent,
  AdminFaqQaComponent,
  EditQaComponent,
  AddQaComponent,
  ModalsConfirmCardComponent,
  NewCardsResultComponent,
  NewCardsListComponent,
  CardRepositionComponent,
  ModalImageAcceptComponent,
  CardApproverResultComponent,
  CardApproverListComponent,
  CardsListResultComponent,
  ModalApproveAcceptComponent,
  AddComponent,
  ProfileComponent,
  ModalApproveAcceptComponent,
  PickupcardsComponent,
  EditComponent,
  NotFoundPageComponent,
  NotModulesComponent,
  ModalsScaleComponent,
  ModalsObservationComponent,
  CheckPolicyManagementComponent,
  EmployeAccessComponent,
  AccessEmployeeListComponent,
  AccessEmployeeResultComponent,
  QualificationsModalComponent,
  AdminBusinessUnitComponent,
  AddBuComponent,
  EditBuComponent,
  AccessApproversListComponent,
  AccessContractComponent,
  SubZoneApproversComponent,
  ModalApproverSubzoneComponent,
  ConfimDeleteApproverComponent,
  AccessIncomingRequestListComponent,
  AccessIncomingRequestDetailsComponent,
  ModalApproveComponent,
  ModalRejectComponent,
  AccessExceptionComponent,
  AccessIncomingRequestConfirmComponent,
  ModalTermsComponent,
  AccessVisitorComponent,
  MyAuthorisedAccessesComponent,
  MyAccessesAuthorisedDetailComponent,
  MyQualificationListComponent,
  AdminI18nSarComponent,
  AdminI18nPublicComponent,
  AdminSelfInformationComponent,
  AddSelfInformationComponent,
  EditSelfInformationComponent,
  DeleteSelfInformationComponent,
  CalificationDummyComponent,
  QualificationDummySubZoneComponent,
  FacilityApproverZoneComponent,
  FacilityApproverSubzoneComponent,
  ModalTermsVisitorComponent,
  ModalTermsAcceptRequestComponent,
  ModalTermsRepositionComponent,
  ModalTerminateComponent,
  PublicFooterComponent,
  PublicHeaderComponent,
  ConfirmationPublicFormComponent,
  LeaderGroupAccessFormComponent,
  ModalConfirmComponent,
  PersonalFormAccessComponent,
  MedicalTestComponent,
  ConfirmationMedicalComponent,
  ModErrorComponent,
  ModalExceptionConfirmComponent,
  SaaDelegateComponent,
  ModalDelegateConfirmationComponent,
  SaaDelegateConfirmationComponent,
  ModalEditDelegateComponent,
  ModalDeleteDelegateComponent,
  ExternalVerificationListComponent,
  ExternalVerificationDetailsComponent,
  NumberDirective,
  UnauthBackendComponent,
  ],
  imports: [
  BrowserModule,
  BrowserAnimationsModule,
  NgbModule,
  MatSnackBarModule,
  MatDialogModule,
  MatButtonModule,
  MatExpansionModule,
  MatAutocompleteModule,
  APP_ROUTING,
  NgxSortableModule,
  MatPaginatorModule,
  FormsModule,
  ReactiveFormsModule,
  MatDatepickerModule,
  MatNativeDateModule,
  HttpClientModule,
  MatSnackBarModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatIconModule,
  MatTooltipModule,
  MatSidenavModule,
  NgxSpinnerModule,
  MatProgressBarModule,
  MatRadioModule,
  AngularDualListBoxModule,
  MatInputModule,
  RecaptchaModule,
  RecaptchaFormsModule,
  OAuthModule.forRoot({
    resourceServer: {
    allowedUrls: ["http://localhost:5001/pages/"],
    sendAccessToken: true,
    },
    }),
  TranslateModule.forRoot({
    loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
    },
    }),
  ],
  providers: [
  SeeAllRequestService,
  MatPaginatorIntl,
  HomeAllRequestService,
  PolicyListService,
  DatePipe,
  FormCheckPolicyService,
  AspectsAdminService,
  PickupListService,
  PolicyApproversListService,
  AdminZoneService,
  AdminSubZoneService,
  AdminFaqSectionService,
  CardApproverService,
  {
  provide: HTTP_INTERCEPTORS,
  useClass: TokenInterceptorService,
  multi: true,
  },
  {
  provide: MatPaginatorIntl,
  useClass: MatPaginatorI18nService,
  },
  ],
  bootstrap: [AppComponent],
  exports: [NgxSpinnerModule],
  })
export class AppModule {}

declare global {
  interface Navigator {
    msSaveBlob: (blob: Blob, fileName: string) => boolean;
  }
}
